import React, {Component} from "react";
import {Card, Form} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";

export default class PartnerUpdateModal extends Component {

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                modalClose={this.props.modalClose}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
            >
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.PartnerInfo}
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        {/* ID（変更不可） */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                {this.props.langText.Body.PartnerId}
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={this.props.state.hm12_id}
                                disabled
                            />
                        </Form.Group>

                        {/* パートナー名 */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                {this.props.langText.Body.PartnerName}
                                <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={this.props.state.name}
                                onChange={(e) => this.props.onTextChange_Limit(e, 'name', this.props.charaLimit.partner_name)}
                                maxLength={this.props.charaLimit.partner_name}
                            />
                        </Form.Group>

                        {/* S3バケット名 */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                {this.props.langText.Body.PartnerS3BucketName}
                                <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={this.props.state.s3_bucket_name}
                                onChange={(e) => this.props.onTextChange_Limit(e, 's3_bucket_name', this.props.charaLimit.partner_s3_bucket_name)}
                                maxLength={this.props.charaLimit.partner_s3_bucket_name}
                            />
                            <Form.Text className="text-muted">
                                {this.props.langText.Body.PartnerS3BucketNameHint}
                            </Form.Text>
                        </Form.Group>

                        {/* ドメイン */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                {this.props.langText.Body.PartnerDomain}
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={this.props.state.domain}
                                onChange={(e) => this.props.onTextChange_Limit(e, 'domain', this.props.charaLimit.partner_domain)}
                                maxLength={this.props.charaLimit.partner_domain}
                            />
                        </Form.Group>

                        {/* 識別子 */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                {this.props.langText.Body.PartnerIdentifier}
                                <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={this.props.state.identifier}
                                onChange={(e) => this.props.onTextChange_Limit(e, 'identifier', this.props.charaLimit.partner_identifier)}
                                maxLength={this.props.charaLimit.partner_identifier}
                            />
                        </Form.Group>

                        {/* オプション */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                {this.props.langText.Body.PartnerOptions}
                            </Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                value={this.props.state.options}
                                onChange={(e) => this.props.propSetState({options: e.target.value})}
                                placeholder='{"key": "value"}'
                            />
                            <Form.Text className="text-muted">
                                {this.props.langText.Body.PartnerOptionsHint}
                            </Form.Text>
                        </Form.Group>

                        {/* 作成日時（変更不可） */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                {this.props.langText.Body.PartnerCreated}
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={this.props.state.created}
                                disabled
                            />
                        </Form.Group>

                        {/* 更新日時（変更不可） */}
                        <Form.Group className="mb-3">
                            <Form.Label>
                                {this.props.langText.Body.PartnerModified}
                            </Form.Label>
                            <Form.Control
                                type="text"
                                value={this.props.state.modified}
                                disabled
                            />
                        </Form.Group>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}
